'use strict';

var React = require('react');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

// tmp/StationMarker.tsx
var SvgStationMarker = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M5.75 10c0-2.07.605-3.89 1.671-5.179C8.475 3.547 10.013 2.75 12 2.75c1.987 0 3.525.797 4.579 2.071C17.645 6.11 18.25 7.931 18.25 10c0 3.888-2.516 7.143-6.25 10.935C8.266 17.143 5.75 13.888 5.75 10ZM12 1.25c-2.431 0-4.394.994-5.735 2.615C4.936 5.472 4.25 7.651 4.25 10c0 4.768 3.244 8.554 7.22 12.53a.75.75 0 0 0 1.06 0c3.976-3.976 7.22-7.763 7.22-12.53 0-2.349-.686-4.528-2.015-6.135C16.394 2.244 14.43 1.25 12 1.25Zm0 12.25a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm2-3.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" }));
var StationMarker_default = SvgStationMarker;

module.exports = StationMarker_default;
